import { DocRole, FolderRole } from '@affine/graphql';

export const OBJECT_ROLE_LABEL_KEYS: Record<string, string> = {
  [DocRole.Manager]: 'com.streamlain.share-menu.option.permission.can-manage',
  [FolderRole.Admin]: 'com.streamlain.share-menu.option.permission.can-manage',
  [DocRole.Editor]: 'com.streamlain.share-menu.option.permission.can-edit',
  [DocRole.Reader]: 'com.streamlain.share-menu.option.permission.can-read',
  [DocRole.None]: 'com.streamlain.share-menu.option.permission.no-access',
};

/** Canonical user-facing object role label. Accepts the React `useI18n()`
 * translator as well as the global `I18n` instance (non-React callers). */
export function objectRoleLabel(t: object, role: string): string {
  const key =
    OBJECT_ROLE_LABEL_KEYS[role] ??
    `com.streamlain.settings.workspace.permissions.role.${role.toLowerCase()}`;
  const translations = t as Record<string, (() => string) | undefined>;
  return translations[key]?.() ?? role;
}
